module.exports = "<div class=\"bank-search\">\n  <fd-form-control\n    type=\"suggest\"\n    name=\"{{ vm.name }}\"\n    label=\"{{ vm.label }}\"\n    model=\"vm.value\"\n    form=\"vm.form\"\n    required=\"true\"\n    options=\"vm.options\"\n    messages=\"vm.suggestBank.messages\"\n    suggest=\"vm.suggestBank\"\n    on-change=\"vm.textChange($event)\"\n    suggest-src=\"vm.suggestBankSrc($viewValue)\"\n    suggest-select=\"vm.suggestBankSelect($item, $model, $label)\"\n  >\n  </fd-form-control>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fino/ng1-bank-search/src/bankSearch.html
// module id = 1107
// module chunks = 12